import { Util } from "common/util";

export const columsFirstSeniority = [
  {
    title: `January`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary1",
        key: "grossSalary1",
        width: 100,
        render: (grossSalary1) =>
          Util.getInstance().formatCurrency(grossSalary1 ? grossSalary1 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary1",
        key: "monthly13thSalary1",
        width: 150,
        render: (monthly13thSalary1) =>
          Util.getInstance().formatCurrency(monthly13thSalary1 ? monthly13thSalary1 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA1",
        key: "monthlyPFNPA1",
        width: 150,
        render: (monthlyPFNPA1) =>
          Util.getInstance().formatCurrency(monthlyPFNPA1 ? monthlyPFNPA1 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload1",
        key: "payload1",
        width: 150,
        render: (payload1) => {
          const found =
            payload1 &&
            payload1.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload1",
        key: "payload1",
        width: 150,
        render: (payload1) => {
          const found =
            payload1 && payload1.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload1",
        key: "payload1",
        width: 150,
        render: (payload1) => {
          const found =
            payload1 &&
            payload1.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload1",
        key: "payload1",
        width: 150,
        render: (payload1) => {
          const found =
            payload1 &&
            payload1.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload1",
        width: 150,
        key: "payload1",
        render: (payload1) => {
          const found =
            payload1 && payload1.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `February`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary2",
        key: "grossSalary2",
        width: 150,
        render: (grossSalary2) =>
          Util.getInstance().formatCurrency(grossSalary2 ? grossSalary2 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary2",
        key: "monthly13thSalary2",
        width: 150,
        render: (monthly13thSalary2) =>
          Util.getInstance().formatCurrency(monthly13thSalary2 ? monthly13thSalary2 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA2",
        key: "monthlyPFNPA2",
        width: 150,
        render: (monthlyPFNPA2) =>
          Util.getInstance().formatCurrency(monthlyPFNPA2 ? monthlyPFNPA2 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload2",
        key: "payload2",
        width: 150,
        render: (payload2) => {
          const found =
            payload2 &&
            payload2.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload2",
        key: "payload2",
        width: 150,
        render: (payload2) => {
          const found =
            payload2 && payload2.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload2",
        width: 150,
        key: "payload2",
        render: (payload2) => {
          const found =
            payload2 &&
            payload2.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload2",
        width: 150,
        key: "payload2",
        render: (payload2) => {
          const found =
            payload2 &&
            payload2.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload2",
        key: "payload2",
        width: 150,
        render: (payload2) => {
          const found =
            payload2 && payload2.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `March`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary3",
        key: "grossSalary3",
        width: 150,
        render: (grossSalary3) =>
          Util.getInstance().formatCurrency(grossSalary3 ? grossSalary3 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary3",
        key: "monthly13thSalary3",
        width: 150,
        render: (monthly13thSalary3) =>
          Util.getInstance().formatCurrency(monthly13thSalary3  ? monthly13thSalary3 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA3",
        key: "monthlyPFNPA3",
        width: 150,
        render: (monthlyPFNPA3) =>
          Util.getInstance().formatCurrency(monthlyPFNPA3 ? monthlyPFNPA3 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload3",
        key: "payload3",
        width: 150,
        render: (payload3) => {
          const found =
            payload3 &&
            payload3.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload3",
        width: 150,
        key: "payload3",
        render: (payload3) => {
          const found =
            payload3 && payload3.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload3",
        width: 150,
        key: "payload3",
        render: (payload3) => {
          const found =
            payload3 &&
            payload3.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload3",
        width: 150,
        key: "payload3",
        render: (payload3) => {
          const found =
            payload3 &&
            payload3.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload3",
        width: 150,
        key: "payload3",
        render: (payload3) => {
          const found =
            payload3 && payload3.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `April`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary4",
        width: 150,
        key: "grossSalary4",
        render: (grossSalary4) =>
          Util.getInstance().formatCurrency(grossSalary4 ? grossSalary4 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary4",
        width: 150,
        key: "monthly13thSalary4",
        render: (monthly13thSalary4) =>
          Util.getInstance().formatCurrency(monthly13thSalary4 ? monthly13thSalary4 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA4",
        key: "monthlyPFNPA4",
        width: 150,
        render: (monthlyPFNPA4) =>
          Util.getInstance().formatCurrency(monthlyPFNPA4 ? monthlyPFNPA4 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload4",
        key: "payload4",
        width: 150,
        render: (payload4) => {
          const found =
            payload4 &&
            payload4.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload4",
        width: 150,
        key: "payload4",
        render: (payload4) => {
          const found =
            payload4 && payload4.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload4",
        width: 150,
        key: "payload4",
        render: (payload4) => {
          const found =
            payload4 &&
            payload4.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload4",
        key: "payload4",
        width: 150,
        render: (payload4) => {
          const found =
            payload4 &&
            payload4.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload4",
        key: "payload4",
        width: 150,
        render: (payload4) => {
          const found =
            payload4 && payload4.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `May`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary5",
        key: "grossSalary5",
        width: 150,
        render: (grossSalary5) =>
          Util.getInstance().formatCurrency(grossSalary5 ? grossSalary5 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary5",
        key: "monthly13thSalary5",
        width: 150,
        render: (monthly13thSalary5) =>
          Util.getInstance().formatCurrency(monthly13thSalary5 ? monthly13thSalary5 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA5",
        key: "monthlyPFNPA5",
        width: 150,
        render: (monthlyPFNPA5) =>
          Util.getInstance().formatCurrency(monthlyPFNPA5 ? monthlyPFNPA5 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload5",
        key: "payload5",
        width: 150,
        render: (payload5) => {
          const found =
            payload5 &&
            payload5.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload5",
        key: "payload5",
        width: 150,
        render: (payload5) => {
          const found =
            payload5 && payload5.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload5",
        width: 150,
        key: "payload5",
        render: (payload5) => {
          const found =
            payload5 &&
            payload5.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload5",
        width: 150,
        key: "payload5",
        render: (payload5) => {
          const found =
            payload5 &&
            payload5.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload5",
        width: 150,
        key: "payload5",
        render: (payload5) => {
          const found =
            payload5 && payload5.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `June`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary6",
        key: "grossSalary6",
        width: 150,
        render: (grossSalary6) =>
          Util.getInstance().formatCurrency(grossSalary6 ? grossSalary6 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary6",
        key: "monthly13thSalary6",
        width: 150,
        render: (monthly13thSalary6) =>
          Util.getInstance().formatCurrency(monthly13thSalary6 ? monthly13thSalary6 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA6",
        key: "monthlyPFNPA6",
        width: 150,
        render: (monthlyPFNPA6) =>
          Util.getInstance().formatCurrency(monthlyPFNPA6 ? monthlyPFNPA6 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload6",
        width: 150,
        key: "payload6",
        render: (payload6) => {
          const found =
            payload6 &&
            payload6.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload6",
        width: 150,
        key: "payload6",
        render: (payload6) => {
          const found =
            payload6 && payload6.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload6",
        key: "payload6",
        width: 150,
        render: (payload6) => {
          const found =
            payload6 &&
            payload6.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload6",
        width: 150,
        key: "payload6",
        render: (payload6) => {
          const found =
            payload6 &&
            payload6.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload6",
        key: "payload6",
        width: 150,
        render: (payload6) => {
          const found =
            payload6 && payload6.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
];

export const columsSecondSeniority = [
  {
    title: `July`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary7",
        key: "grossSalary7",
        width: 150,
        render: (grossSalary7) =>
          Util.getInstance().formatCurrency(grossSalary7 ? grossSalary7 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary7",
        key: "monthly13thSalary7",
        width: 150,
        render: (monthly13thSalary7) =>
          Util.getInstance().formatCurrency(monthly13thSalary7 ? monthly13thSalary7 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA7",
        key: "monthlyPFNPA7",
        width: 150,
        render: (monthlyPFNPA7) =>
          Util.getInstance().formatCurrency(monthlyPFNPA7 ? monthlyPFNPA7 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload7",
        key: "payload7",
        width: 150,
        render: (payload7) => {
          const found =
            payload7 &&
            payload7.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload7",
        key: "payload7",
        width: 150,
        render: (payload7) => {
          const found =
            payload7 && payload7.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload7",
        key: "payload7",
        width: 150,
        render: (payload7) => {
          const found =
            payload7 &&
            payload7.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload7",
        key: "payload7",
        width: 150,
        render: (payload7) => {
          const found =
            payload7 &&
            payload7.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload7",
        key: "payload7",
        width: 150,
        render: (payload7) => {
          const found =
            payload7 && payload7.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `August`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary8",
        key: "grossSalary8",
        width: 150,
        render: (grossSalary8) =>
          Util.getInstance().formatCurrency(grossSalary8 ? grossSalary8 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary8",
        key: "monthly13thSalary8",
        width: 150,
        render: (monthly13thSalary8) =>
          Util.getInstance().formatCurrency(monthly13thSalary8 ? monthly13thSalary8 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA8",
        key: "monthlyPFNPA8",
        width: 150,
        render: (monthlyPFNPA8) =>
          Util.getInstance().formatCurrency(monthlyPFNPA8 ? monthlyPFNPA8 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload8",
        key: "payload8",
        width: 150,
        render: (payload8) => {
          const found =
            payload8 &&
            payload8.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload8",
        key: "payload8",
        width: 150,
        render: (payload8) => {
          const found =
            payload8 && payload8.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload8",
        key: "payload8",
        width: 150,
        render: (payload8) => {
          const found =
            payload8 &&
            payload8.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload8",
        key: "payload8",
        width: 150,
        render: (payload8) => {
          const found =
            payload8 &&
            payload8.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload8",
        key: "payload8",
        width: 150,
        render: (payload8) => {
          const found =
            payload8 && payload8.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `September`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary9",
        key: "grossSalary9",
        width: 150,
        render: (grossSalary9) =>
          Util.getInstance().formatCurrency(grossSalary9   ? grossSalary9 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary9",
        key: "monthly13thSalary9",
        width: 150,
        render: (monthly13thSalary9) =>
          Util.getInstance().formatCurrency(monthly13thSalary9 ? monthly13thSalary9 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA9",
        key: "monthlyPFNPA9",
        width: 150,
        render: (monthlyPFNPA9) =>
          Util.getInstance().formatCurrency(monthlyPFNPA9 ? monthlyPFNPA9 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload9",
        key: "payload9",
        width: 150,
        render: (payload9) => {
          const found =
            payload9 &&
            payload9.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload9",
        key: "payload9",
        width: 150,
        render: (payload9) => {
          const found =
            payload9 && payload9.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload9",
        key: "payload9",
        width: 150,
        render: (payload9) => {
          const found =
            payload9 &&
            payload9.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload9",
        key: "payload9",
        width: 150,
        render: (payload9) => {
          const found =
            payload9 &&
            payload9.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload9",
        key: "payload9",
        width: 150,
        render: (payload9) => {
          const found =
            payload9 && payload9.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `October`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary10",
        key: "grossSalary10",
        width: 150,
        render: (grossSalary10) =>
          Util.getInstance().formatCurrency(grossSalary10 ? grossSalary10 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary10",
        key: "monthly13thSalary10",
        width: 150,
        render: (monthly13thSalary10) =>
          Util.getInstance().formatCurrency(monthly13thSalary10 ? monthly13thSalary10 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA10",
        key: "monthlyPFNPA10",
        width: 150,
        render: (monthlyPFNPA10) =>
          Util.getInstance().formatCurrency(monthlyPFNPA10 ? monthlyPFNPA10 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload10",
        key: "payload10",
        width: 150,
        render: (payload10) => {
          const found =
            payload10 &&
            payload10.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload10",
        key: "payload10",
        width: 150,
        render: (payload10) => {
          const found =
            payload10 &&
            payload10.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload10",
        key: "payload10",
        width: 150,
        render: (payload10) => {
          const found =
            payload10 &&
            payload10.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload10",
        key: "payload10",
        width: 150,
        render: (payload10) => {
          const found =
            payload10 &&
            payload10.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload10",
        key: "payload10",
        width: 150,
        render: (payload10) => {
          const found =
            payload10 &&
            payload10.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `November`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary11",
        key: "grossSalary11",
        width: 150,
        render: (grossSalary11) =>
          Util.getInstance().formatCurrency(grossSalary11 ? grossSalary11 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary11",
        key: "monthly13thSalary11",
        width: 150,
        render: (monthly13thSalary11) =>
          Util.getInstance().formatCurrency(monthly13thSalary11 ? monthly13thSalary11 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA11",
        key: "monthlyPFNPA11",
        width: 150,
        render: (monthlyPFNPA11) =>
          Util.getInstance().formatCurrency(monthlyPFNPA11 ? monthlyPFNPA11 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload11",
        key: "payload11",
        width: 150,
        render: (payload11) => {
          const found =
            payload11 &&
            payload11.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload11",
        key: "payload11",
        width: 150,
        render: (payload11) => {
          const found =
            payload11 &&
            payload11.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload11",
        width: 150,
        key: "payload11",
        render: (payload11) => {
          const found =
            payload11 &&
            payload11.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload11",
        key: "payload11",
        width: 150,
        render: (payload11) => {
          const found =
            payload11 &&
            payload11.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload11",
        key: "payload11",
        width: 150,
        render: (payload11) => {
          const found =
            payload11 &&
            payload11.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
  {
    title: `December`,
    children: [
      {
        title: "Pay Basic",
        dataIndex: "grossSalary12",
        key: "grossSalary12",
        width: 150,
        render: (grossSalary12) =>
          Util.getInstance().formatCurrency(grossSalary12 ? grossSalary12 : 0),
      },
      {
        title: "Monthly 13th salary",
        dataIndex: "monthly13thSalary12",
        key: "monthly13thSalary12",
        width: 150,
        render: (monthly13thSalary12) =>
          Util.getInstance().formatCurrency(monthly13thSalary12 ? monthly13thSalary12 : 0),
      },
      {
        title: "Monthly PF NPA",
        dataIndex: "monthlyPFNPA12",
        key: "monthlyPFNPA12",
        width: 150,
        render: (monthlyPFNPA12) =>
          Util.getInstance().formatCurrency(monthlyPFNPA12 ? monthlyPFNPA12 : 0),
      },
      {
        title: "Hardship Allowance",
        dataIndex: "payload12",
        key: "payload12",
        width: 150,
        render: (payload12) => {
          const found =
            payload12 &&
            payload12.find((item) => item.k === "hardship_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Housing Allowance",
        dataIndex: "payload12",
        key: "payload12",
        width: 150,
        render: (payload12) => {
          const found =
            payload12 &&
            payload12.find((item) => item.k === "housing_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Gasoline Allowance",
        dataIndex: "payload12",
        key: "payload12",
        width: 150,
        render: (payload12) => {
          const found =
            payload12 &&
            payload12.find((item) => item.k === "gasoline_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Adjustment Allowance",
        dataIndex: "payload12",
        key: "payload12",
        width: 150,
        render: (payload12) => {
          const found =
            payload12 &&
            payload12.find((item) => item.k === "adjustment_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
      {
        title: "Living Allowance",
        dataIndex: "payload12",
        width: 150,
        key: "payload12",
        render: (payload12) => {
          const found =
            payload12 &&
            payload12.find((item) => item.k === "living_allowance");
          if (found) {
            return Util.getInstance().formatCurrency(found.a);
          }
          return Util.getInstance().formatCurrency(0);
        },
      },
    ],
  },
];
